import Vue from 'vue'
import axios from 'axios'
import Storage from 'vue-ls'
import { Modal } from 'ant-design-vue'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

Vue.use(Storage)

const service = axios.create()
let fp = Vue.ls.get('Fingerprint')

if (!fp) {
  (async () => {
    // We recommend to call `load` at application startup.
    const finger = await FingerprintJS.load()

    // The FingerprintJS agent is ready.
    // Get a visitor identifier when you'd like to.
    const result = await finger.get()

    // This is the visitor identifier:
    fp = result.visitorId
    Vue.ls.set('Fingerprint', fp)
  })()
}

let requestBackup = null
window.__MICRO_ROOT__?.eventBus?.on('user.login.modal:success', () => {
  if (requestBackup) {
    service(requestBackup.request).then(function (data) {
      requestBackup.resolve(data)
      requestBackup = null
    }).catch(function (err) {
      requestBackup.reject(err)
      requestBackup = null
    })
  }
})

// request interceptor
service.interceptors.request.use(request => {
  const token = Vue.ls.get('USER_CENTER_TOKEN')

  if (token) {
    request.headers.token = token
  }

  if (fp) {
    request.headers.browser = fp
  }

  return request
}, err => {
  return Promise.reject(err)
})

service.interceptors.response.use(response => {
  return new Promise((resolve, reject) => {
    const { status, data: result, headers, config } = response

    const token = Vue.ls.get('USER_CENTER_TOKEN')

    if (headers.token && token !== headers.token) {
      Vue.ls.set('USER_CENTER_TOKEN', headers.token, 2 * 60 * 60 * 1000)
    }

    if (status === 200) {
      const { code, data, message } = result

      if (code === 0) {
        resolve(data)
      } else {
        if (code === 100020007) {
          requestBackup = {
            request: config,
            resolve,
            reject
          }
          Modal.error({
            content: message || '请先登录！',
            onOk: () => {
              window.top.postMessage('TokenExpired::Error', '*')
              window.__MICRO_ROOT__.eventBus.emit('user.expired', null, {
                isModal: true
              })
            }
          })
        } else {
          const err = new Error(message || '网络异常，请稍后再试！')
          err.code = code

          if (data) {
            err.data = data
          }

          reject(err)
        }
      }
    } else {
      reject(new Error(`status: ${status}`))
    }
  })
}, err => {
  console.error('request error: ', err)
  return Promise.reject(err)
})

export default {
  vm: {},
  install (Vue) {
    Vue.prototype.$axios = service
  }
}

export {
  service as axios
}
